import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    LinearProgress,
    Tooltip,
} from '@mui/material';

import './programList.css';
import { getDataList } from '../../../../helpers/getDataList';
import PageHeader from '../../includes/PageHeader';
import showMessage from '../../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/system';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../../configs/messages';
import { deleteData } from '../../../../helpers/deleteData';
import {
    APPROVE_STATUS_APPROVED,
    APPROVE_STATUS_DISAPPROVED,
} from '../../../../configs/constants';

export function ProgramsList() {
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
        },
        {
            field: 'broadcastWeek',
            headerName: 'Огноо',
            flex: 1,
        },
        {
            field: 'channel',
            headerName: 'ТВ суваг',
            flex: 1,
        },
        // {
        //     field: 'status',
        //     headerName: 'Баталсан эсэх',
        //     flex: 1,
        //
        // },

        {
            field: 'delete',
            headerName: 'Устгах',
            renderCell: (params) => {
                return (
                    <div>
                        <Tooltip title="Устгах">
                            <IconButton
                                style={{ color: 'red' }}
                                onClick={() => showDelete(params.id)}
                            >
                                <DeleteOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                );
            },
            flex: 1,
        },
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [programList, setProgramList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [showDeleteValidation, setShowDeleteValidation] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [khRefresh, setKhRefresh] = useState({});
    const [pageSize, setPageSize] = useState(100);

    useEffect(() => {
        let isActive = true;

        getDataList('program-list')
            .then((response) => {
                if (isActive) {
                    const dataArr = response.data?.data;

                    dataArr.forEach((data) => {
                        data.status =
                            data.status === APPROVE_STATUS_APPROVED
                                ? 'Тийм'
                                : data.status === APPROVE_STATUS_DISAPPROVED
                                ? 'Үгүй'
                                : 'Хүлээгдэж байна';
                        data.channel = data.channel ? data.channel.name : null;
                    });

                    setProgramList(dataArr);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        return () => {
            isActive = false;
        };
    }, [khRefresh]);

    const showDelete = (id) => {
        setShowDeleteValidation(true);
        setDeleteId(id);
    };

    const handleDelete = () => {
        setShowDeleteValidation(false);
        if (deleteId) {
            deleteData(`program-list/${deleteId}`)
                .then(() => {
                    showMessage(SUCCESS_MESSAGES.DELETED_DATA, enqueueSnackbar);
                    // history.push(ROUTES_LIST.programList);
                    setKhRefresh({});
                })
                .catch((error) => {
                    console.error(error);
                    showMessage(
                        error.response?.data?.message
                            ? error.response.data.message
                            : ERROR_MESSAGES.REQUEST_FAIL,
                        enqueueSnackbar,
                        'error',
                    );
                });
        }
    };

    const handleDeleteCancel = () => {
        setShowDeleteValidation(false);
        setDeleteId(null);
    };

    return (
        <Grid
            container
            justifyContent="center"
            style={{ height: 630, width: '100%' }}
        >
            <PageHeader pageName="Хөтөлбөр" showAddNew={false} />
            {isLoading ? (
                <Box sx={{ width: '100%' }}>
                    <LinearProgress />
                </Box>
            ) : (
                <DataGrid
                    rows={programList}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                    rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    pagination
                    // checkboxSelection
                    disableSelectionOnClick
                />
            )}
            <Dialog
                open={showDeleteValidation}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Та энэхүү мэдээллийг устгахыг хүсэж байна уу?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Та энэ мэдээллийг устгахыг хүсэж байвал &apos;Тийм&apos;
                        товчийг дарна уу.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleDeleteCancel}>
                        Болих
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleDelete}
                        autoFocus
                    >
                        Тийм
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}
